<script setup>
import LoadingSpinner from '@js/components/LoadingSpinner.vue';
import { Form } from 'vee-validate';
import { inject, provide, ref } from 'vue';

const {
    validationSchema,
    submit,
    loading = false,
} = defineProps({
    validationSchema: {
        type: Object,
        required: true,
    },
    submit: {
        type: Function,
        required: true,
    },
    loading: {
        type: Boolean,
        required: false,
    },
});

const isInDialogDrawer = inject('isInDialogDrawer', false);
const isInDialogModal = inject('isInDialogModal', false);

provide('isInFormRoot', true);

const formRef = ref(null);

defineExpose({
    getMeta: () => formRef.value?.getMeta(),
});
</script>

<template>
    <LoadingSpinner v-if="loading" :class="{ 'p-4': isInDialogModal }" />

    <Form
        v-else
        ref="formRef"
        v-slot="{ errors, validate }"
        :validation-schema="validationSchema"
        @submit="submit"
        novalidate
        :class="{
            'flex h-full flex-col': isInDialogDrawer,
        }"
    >
        <slot :errors="errors" :validate="validate" />
    </Form>
</template>
